import { useAuth } from '@/hooks/useAuth';
import { hasPermission } from '@/lib/permissions';
import { useMemo } from 'react';

/**
 * Custom hook for email-template-related permissions
 *
 * Provides memoized permission checks for email-template operations:
 * - canRead: Can read existing email-templates
 * - canCreate: Can create new email-templates
 * - canEdit: Can edit existing email-templates
 * - canDelete: Can delete existing email-templates
 */
export const useEmailTemplatePermissions = () => {
  const { user } = useAuth();

  const permissions = useMemo(
    () => ({
      canRead: hasPermission(user, 'email-templates', 'read'),
      canCreate: hasPermission(user, 'email-templates', 'create'),
      canEdit: hasPermission(user, 'email-templates', 'edit'),
      canDelete: hasPermission(user, 'email-templates', 'delete'),
    }),
    [user]
  );

  return permissions;
};
